import { Button } from "@edgetier/components";
import { getServerError } from "@edgetier/utilities";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import Axios from "axios";
import { FunctionComponent, memo, useEffect, useRef, useState } from "react";
import { hotToastOperations } from "utilities-for/toast";
import "./download-email-transcript-button.scss";
import { IProps } from "./download-email-transcript-button.types";
import { downloadEmailTranscript } from "./download-email-transcript-button.utilities";

/**
 * Button for downloading email transcript
 * @param props.emailId
 */
const DownloadEmailTranscriptButton: FunctionComponent<IProps> = ({ conversationId }) => {
    const cancelTokenSource = useRef(Axios.CancelToken.source());
    const [submitting, setSubmitting] = useState(false);

    /**
     * Submit request for download email transcript
     */
    const onDownload = async () => {
        try {
            setSubmitting(true);
            await downloadEmailTranscript(conversationId, {
                cancelToken: cancelTokenSource.current.token,
                params: { includeAllContent: true },
            });
        } catch (serverError) {
            hotToastOperations.showErrorToast(getServerError(serverError));
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        return cancelTokenSource.current.cancel;
    }, [cancelTokenSource]);

    return (
        <Button
            className="download-email-transcript__button button--no-modal"
            icon={faDownload}
            isLoading={submitting}
            onClick={onDownload}
            isIconOnly
            aria-label="Download email transcript"
        />
    );
};

export default memo(DownloadEmailTranscriptButton);
